import { render, staticRenderFns } from "./BAWorksheet.vue?vue&type=template&id=cd2641dc&scoped=true&"
import script from "./BAWorksheet.vue?vue&type=script&lang=ts&"
export * from "./BAWorksheet.vue?vue&type=script&lang=ts&"
import style0 from "./BAWorksheet.vue?vue&type=style&index=0&id=cd2641dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2641dc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/iwata/Documents/Project/SMILE-AYA/dev/smileaya-admin-web/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout})
